import {Container, Modal, Row, Col, Button, Form, Tooltip} from "react-bootstrap";
import { useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import {Icon} from '@iconify/react';
import APICom from '../../utils/helpers/APICom.js';
import GridControl from "./gridControl.js";
import ClearFilterIcon from "../../assets/Images/CommonImages/clearFilter.png";

const CCProfile = (props) => {
    //#region Initial Variables
    const { ASCSSettingData, GlobalASCSData } = useSelector((store) => store.combinedata);
    const [CCInfoGridData, setCCInfoGridData] = useState([]);
    const [cardInfo, setCardInfo] = useState(props.CardDetails);
    const [warningMessage, setWarningMessage] = useState("");
    const [clientData, setClientData] = useState(props.clientInfoData);
    const [cardToRemove, setCardToRemove] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const [showPageLoader, setShowPageLoader] = useState(false);
    const [AddCardDisable, setAddCardDisable] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [slimCDSessionURL, setSlimCDSessionURL] = useState("");
    const [AuthorizeNetSessionURL, setAuthorizeNetSessionURL] = useState("");
    const [AuthorizeNetToken, setAuthorizeNetToken] = useState("");
    const [showCCInfoDialog, setShowCCInfoDialog] = useState(props.bCCInfoDialogOpen);
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBodyHTML, setModalBodyHTML] = useState(null);
    const [modalFooterHTML, setModalFooterHTML] = useState(
      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
        OK
      </Button>
    );
    const [authorizeActionStatus, setAuthorizeActionStatus] = useState(() => {
        // Get the initial value from sessionStorage on mount
        return JSON.parse(sessionStorage.getItem('authorizeAction')) || null;
    });
    const bankChoiceFromSettings = useRef((props.AffID && ASCSSettingData[props.AffID] ? 
        (JSON.parse(ASCSSettingData[props.AffID]).find((item)=>item.SubTitle === "CCOnProfileProcessingCompany").value) : -1)
    );
    const globalInLoadAPIURL = useRef((GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL") ? GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL").value : ""));
    const checkSessionCounter = useRef(0);
    const slimCDSessionID = useRef("");
    const slimCDCCInfo = useRef({});
    const CCInfoTableObjRef = useRef(null);
    const cardInfoRef = useRef({selectedCard: props.CardDetails.selectedCard});
    const authorizeNetFormRef = useRef(null);
    const removeCCFlagRef = useRef(false);
    const createdClientIDRef = useRef(0);
    const [CCInfoGridOptions, setCCInfoGridOptions] = useState({
        height: 320,
        heightoffset: 600,
        calculateHeight: false,
        pagination: false,
        sortCondition: true,
        paginationSize: 5,
        paginationSizeSelector: [5, 10, 15, 20, 25],
        selectable: 1,
        reactiveData:false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"CCInfoGrid",
        paginationCounter:"rows",
        intervalTimer: 0,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "UniqueID",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        customWidthCols: ["CardType-127"],
        footerElement: '<button class="tabulator_btns raised-button border border-dark " '
        +' title="Clear Filters" id="'+"CCInfoGrid"+'_ClearFilters"></button><p class="m-0 my-1">Showing 1 of 1 Page</p>',
        tableDoubleClickFunc: function(table, row) {

        },
        footerElementHandles: function (table) {
            CCInfoTableObjRef.current = table;
            if(CCInfoTableObjRef.current.getDataCount() > 0)
            {
                CCInfoTableObjRef.current.selectRow(CCInfoTableObjRef.current.getData()[0].UniqueID);
            }
            let img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ClearFilterIcon;
                document.getElementById("CCInfoGrid_ClearFilters").appendChild(img);
            document.getElementById('CCInfoGrid_ClearFilters').addEventListener("click", function(){
                table.clearHeaderFilter();
            });
        },
        rowSelectionChangeHandle: function (data) {  
            try{
                if(data.length === 1)
                {
                    setCardInfo(prevState=>({...prevState, selectedCard: data[0].Last4Digits, selectedExpiry: data[0].ExpiryDate, 
                        selectedCardType: data[0].CardType, uniqueID: data[0].UniqueID, gateID: "", response: ""
                    })); 
                    cardInfoRef.current.selectedCard = data[0].Last4Digits;
                }
            }
            catch(err){console.log(err);}
        },
        ActionList: true,
        AlwaysHiddenColumns: ["UniqueID", "Zip"]
    });

    //#endregion

    //#region UseEffects
    useEffect(() => {
        //Initial load of the component
        try{
            initializeCCTable();
        }
        catch(err){console.log(err);}
    }, []);

    useEffect(() => {
     try{
        if(props.checkCCParams && props.checkCCParams !== "")
        {
            CheckCCAmount(props.checkCCParams);
        }
     }  
     catch(err){console.log(err);} 
    }, [props.checkCCParams])

    useEffect(() => {
        try{
          //Function to catch and remove selected card chosen by user
          if(cardToRemove !== "")
          {
            setModalHeaderText("Remove CC Alert");
            setModalBodyHTML("Are you sure you want to delete this Credit Card from profile?");
            setModalFooterHTML(
                <>
                    <Button variant='dark' className="border-0" onClick={()=>{handleRemoveCard(cardToRemove); setCardToRemove(""); setShowDynamicModal(false);}}>
                        Yes
                    </Button>
                    <Button variant='secondary' className="border-0" onClick={()=>{setShowDynamicModal(false); setCardToRemove("");}}>
                        No
                    </Button>
                </>
            );
            setShowDynamicModal(true);
          }
        }
        catch(err){console.log(err);}
    }, [cardToRemove]);

    useEffect(() => {
        try{
            if(authorizeNetFormRef.current)
            {
                authorizeNetFormRef.current.submit();
                setFormSubmitted(true); //mark form as submitted
                setShowPageLoader(false);
                setCCInfoGridOptions(prevState=>({...prevState, height: 200}));
            }
        }
        catch(err){console.log(err); setShowPageLoader(false);}
    }, [AuthorizeNetToken]);

    useEffect(() => {
        try{
            const interval = setInterval(() => {
                const currentValue = JSON.parse(sessionStorage.getItem('authorizeAction'));
                if (currentValue !== authorizeActionStatus) {
                    setAuthorizeActionStatus(currentValue);
                    if(currentValue && currentValue.action.includes("="))
                    {
                        if(currentValue.action.split("=")[1].toLowerCase() === "cancel")
                        {
                            sessionStorage.removeItem("authorizeAction");
                            setCCInfoGridOptions(prevState=>({...prevState, height: 320}));
                            setAuthorizeNetSessionURL("");
                            setFormSubmitted(false);
                            setAddCardDisable(false);
                            if(cardInfoRef.current.selectedCard === "")
                            {
                                setWarningMessage("No existing cards found. Please first add a card to client profile.");
                            }
                        }
                        else if(currentValue.action.split("=")[1].toLowerCase() === "successfulsave")
                        {
                            sessionStorage.removeItem("authorizeAction");
                            setTimeout(() => {
                                setCCInfoGridOptions(prevState=>({...prevState, height: 320}));
                                setAuthorizeNetSessionURL("");
                                setFormSubmitted(false);
                                setAddCardDisable(false);
                                handleGetCustomerProfileSuccessfulSave();
                            }, 2000);
                        }
                        else if(currentValue.action.split("=")[1].toLowerCase() === "transactresponse")
                        {
                            let resultData = JSON.parse(currentValue.response);
                            sessionStorage.removeItem("authorizeAction");
                            if(resultData && resultData.responseCode === 1)
                            {
                                //Save CC Transaction & send email
                                setShowLoader(true);
                                handleSaveCCTransactionAuthNet(resultData);
                            }
                            else
                            {
                                setModalHeaderText("Manual CC Charge Alert");
                                setModalBodyHTML("Failed to charge the Credit Card.");
                                setModalFooterHTML(
                                    <>
                                        <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                                            OK
                                        </Button>
                                    </>
                                );
                                setShowDynamicModal(true);
                            }
                        }
                    }
                }
            }, 1000); // Poll every second
    
            // Cleanup the interval when the component unmounts
            return () => {
                clearInterval(interval);
            };
        }
        catch(err){console.log(err);}
    }, [authorizeActionStatus]);
    //#endregion
    
    //#region Authorize.net APIs & functions
    const handleGetCustomerProfileSuccessfulSave = async () => {
        try{
            let myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let clientID = (props.clientInfoData.Id ? props.clientInfoData.Id : -1);
            let APIData = {"clientID": parseInt(clientID), "iAffiliateID": parseInt(props.AffID), "ForFS": false};
            let GetCCProfileSuccessfulSaveResponse = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/GetCustomerProfileAuthNet", "post", headersObj, APIData);
            if(GetCCProfileSuccessfulSaveResponse && GetCCProfileSuccessfulSaveResponse.error === "")
            {
                if(GetCCProfileSuccessfulSaveResponse.data !== "")
                {
                    let parsedData = JSON.parse(GetCCProfileSuccessfulSaveResponse.data);
                    if(parsedData.messages.resultCode.toUpperCase() === "OK")
                    {
                        let syncData = parsedData.profile.paymentProfiles.length > 0 ? parsedData.profile.paymentProfiles.map((item, index) => {
                            let cardDetails = item.payment.creditCard;
                            let expiration = item.payment.creditCard.expirationDate;
                            expiration = (expiration.includes("-") ? (expiration.split("-")[1]+"/"+expiration.split("-")[0].slice(2)) : expiration);
                            return {
                                CardNo: cardDetails.cardNumber,
                                CardExpiry: cardDetails.expirationDate,
                                CardType: cardDetails.cardType,
                                PaymentProfileID: item.customerPaymentProfileId,
                                ClientID: clientID,
                                ForFS: false,
                                AffiliateID: String(props.AffID)
                            };
                        }) : [];
                        // console.log(JSON.stringify(syncData));
                        await syncPaymentProfilesAuthNet(JSON.stringify(syncData));
                    }
                }
            }
            else
            {
                let errorMsg = (GetCCProfileSuccessfulSaveResponse.error && typeof GetCCProfileSuccessfulSaveResponse.error === "string" ? 
                    GetCCProfileSuccessfulSaveResponse.error : "An error occurred while loading the card, please try again later."
                );
                setWarningMessage(errorMsg);
            }
            setShowLoader(false);

        }
        catch(err){console.log(err);}
    };

    const handleAddCCAuthorizeNet = async (inLoadAPIURL) => {
        try{
            let updateKey = (props.clientInfoData.Id ? props.clientInfoData.Id : -1);
            let myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let startSessionData = {
                "userid": parseInt(updateKey), 
                "AffID": parseInt(props.AffID), 
                "ForFS": false,
                "ResponseURL": window.location.origin + "/Communicator",
            };
            let createSessionAPIURL = inLoadAPIURL + "/Payment/GetTokenForAddCardAuthNet";
            setShowPageLoader(true);
            let CreateSessionResponse = await APICom.fetchData("full", createSessionAPIURL, "post", headersObj, startSessionData);
            if(CreateSessionResponse && CreateSessionResponse.error.length === 0)
            {
                let tokenData = JSON.parse(CreateSessionResponse.data);
                if(tokenData.messages.resultCode.toUpperCase() === "OK")
                {
                    createdClientIDRef.current = 0;
                    handleAuthorizeNetSuccessSession(tokenData.token);
                }
            }
            else 
            {
                if(CreateSessionResponse.error.includes('500')){
                    if(createdClientIDRef.current === 0){
                        await handleCreateCustomerAuthNet(inLoadAPIURL, updateKey);
                    }
                    else {
                        setTimeout(async () => {
                            await handleAddCCAuthorizeNet(inLoadAPIURL);
                        }, 5000);
                    }
                }
                else{
                    setAddCardDisable(false);
                    setModalHeaderText("Initializing Session Error");
                    setModalBodyHTML(CreateSessionResponse.error);
                    setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                            OK
                        </Button>
                    );
                    setShowDynamicModal(true);
                    setShowPageLoader(false);
                }
                
            }
        }
        catch(err){console.log(err); setShowPageLoader(false); setAddCardDisable(false); setWarningMessage("An error occured when adding the card, please try again later.");}
    };

    const handleCreateCustomerAuthNet = async (inloadURL = '', userID = -1) => {
        try{
            let myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let profileData = {
                "userid": parseInt(userID), 
                "AffID": parseInt(props.AffID)
            };
            let createProfileAPIURL = inloadURL + "/Payment/CreateCustomerProfileAuthNet";
            setShowPageLoader(true);
            let CreateProfileAuthResponse = await APICom.fetchData("full", createProfileAPIURL, "post", headersObj, profileData);
            if(CreateProfileAuthResponse && CreateProfileAuthResponse.error.length === 0)
            {
                const response = JSON.parse(CreateProfileAuthResponse.data);
                if(response.messages.resultCode.trim().toUpperCase() === 'OK'){
                    createdClientIDRef.current = response.customerProfileId;
                    await handleAddCCAuthorizeNet(inloadURL);
                }
                else
                {
                    setAddCardDisable(false);
                    setModalHeaderText("Create Customer Profile Alert");
                    setModalBodyHTML('Customer profile is not created at the Auth.Net Gateway, please try again later.');
                    setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                            OK
                        </Button>
                    );
                    setShowDynamicModal(true);
                    setShowPageLoader(false);
                }
            }
            else
            {
                setAddCardDisable(false);
                setModalHeaderText("Create Customer Profile Error");
                setModalBodyHTML(CreateProfileAuthResponse.error);
                setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                        OK
                    </Button>
                );
                setShowDynamicModal(true);
                setShowPageLoader(false);
            }

        }
        catch(err) { console.log(err); setShowPageLoader(false); setAddCardDisable(false); setWarningMessage("An error occured when adding the card, please try again later."); }
    };

    const handleSaveCCTransactionAuthNet = async (authNetTransactionResponse) => { //Pending Transaction function
        let myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');
        let headersObj = headersToObject(myHeaders);
        let ForFS = false;
        let isRefundTrans = false;
        let RefID = "-1";
        let ServiceID = "-1";
        let ScheduleID = "-1";
        let CardType = "-1";
        let CardNo = "-1";
        let AuthCode = "-1";
        let Amount = "0";
        let TransactionDate = new Date();
        let TransactionID = "-1";
        let PaymentType = "";
        let OriginalTransactionID = "";

        const checkFSAlert = (ForFS) => {
            try{
                setAuthorizeNetSessionURL("");
                setFormSubmitted(false);
                setAddCardDisable(false);
                if(!ForFS)
                {
                    setModalHeaderText("Manual CC Charge Alert");
                    setModalBodyHTML("CC Transaction has been charged from credit card successfully but could not save CC Tran. in the system.");
                    setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                            OK
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else
                {
                    setModalHeaderText("Manual CC Charge Alert");
                    setModalBodyHTML("Invoice has been charged from credit card successfully but could not save CC Tran. in the system.");
                    setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                            OK
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
            }
            catch(err){console.log(err);}
        };
        try{
            let APIData = {"RefID": RefID, "ForFS": String(ForFS), "ServiceID": ServiceID, 
                "ScheduleID": ScheduleID, "CardType": CardType, "CardNo": CardNo, "AuthCode": AuthCode, "Amount": Amount, 
                "TransactionID": TransactionID, "TransactionDate": TransactionDate, "TransactionType": (isRefundTrans ? "Refund" : "Sale"), 
                "PaymentType": PaymentType, "OriginalTransactionID": OriginalTransactionID
            };
            let url = globalInLoadAPIURL.current + "/Payment/SaveCCTransaction";
            let saveCCTransacResponse = await APICom.fetchData("full", url, "post", headersObj, APIData);
            if(saveCCTransacResponse.data !== "")
            {
                if(parseInt(saveCCTransacResponse.data) > 0)
                {
                    setAuthorizeNetSessionURL("");
                    setFormSubmitted(false);
                    setAddCardDisable(false);
                    if(!ForFS)
                    {
                        //Pending Function
                    }
                    else
                    {
                        handleSaveAndPostReceipt(); //Pending Function
                        handleSendEmailToFSForCC(); //Pending Function
                    }
                    return;
                }
            }
            checkFSAlert(ForFS);
        }
        catch(err){
            console.log(err); setShowLoader(false);
            checkFSAlert(ForFS);
        }
    };

    const handleSaveAndPostReceipt = () => { //Pending Function
        try{

        }
        catch(err){console.log(err); setShowLoader(false);}
    };

    const handleSendEmailToFSForCC = () => { //Pending Function
        try{

        }
        catch(err){console.log(err); setShowLoader(false);}
    };

    const handleGetActiveCCInfo = async (e) => {
        try{
            setWarningMessage("Card Table loading, please wait...");
            let myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let iUserID = (props.clientInfoData.Id ? props.clientInfoData.Id : -1);
            let getProfileAPIData = {"iUserID": String(iUserID), "iAffiliateID": String(props.AffID)};
            let getCustomerProfileResponse = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/GetAllActiveCCProfile", "post", headersObj, getProfileAPIData);
            if(getCustomerProfileResponse && getCustomerProfileResponse.error === "")
            {
                if(getCustomerProfileResponse.data.length > 0)
                {
                    // console.log(getCustomerProfileResponse);
                    let paymentData = getCustomerProfileResponse.data.length > 0 ? getCustomerProfileResponse.data.map((item, index) => {
                        return {
                            UniqueID: parseInt(item.UniqueID),
                            CardType: item.CardType,
                            Last4Digits: item.Last4Digits,
                            ExpiryDate: item.ExpiryDate,
                        };
                    }) : [];
                    setCCInfoGridData(paymentData);
                    setShowLoader(false); setWarningMessage("");
                }
                else
                {
                    setShowLoader(false); setWarningMessage("No existing cards found. Please first add a card to client profile.");
                    setCCInfoGridData([{UniqueID:-1, CardType: "", Last4Digits: "", ExpiryDate: ""}]);
                }
            }
            else
            {
                setCCInfoGridData([{UniqueID:-1, CardType: "", Last4Digits: "", ExpiryDate: ""}]);
                setShowLoader(false); setWarningMessage("No existing cards found. Please first add a card to client profile.");
            }
        }
        catch(err){
            console.log(err); setShowLoader(false); 
            setWarningMessage("No existing cards found. Please first add a card to client profile."); 
            setCCInfoGridData([{UniqueID:-1, CardType: "", Last4Digits: "", ExpiryDate: ""}]);
        }
    };

    const syncPaymentProfilesAuthNet = async (JSONData) =>{ //Pending function
        try{
            if(JSONData !== "[]")
            {
                let tableData = JSON.parse(JSONData);
                let myHeaders = new Headers();
                    myHeaders.append('Content-Type', 'application/json');
                let headersObj = headersToObject(myHeaders);
                let syncCPResponse = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/SyncPaymentProfiles", "post", headersObj, tableData);
                // console.log(syncCPResponse);
                if(syncCPResponse && syncCPResponse.error === "")
                {
                    if(syncCPResponse.data !== "" && syncCPResponse.data !== "-1")
                        await handleGetActiveCCInfo();
                }
                else
                {
                    await handleGetActiveCCInfo();
                }
            }
            setShowLoader(false);
            setWarningMessage("");
        }
        catch(err){console.log(err); setShowLoader(false);}
    };

    const handleAuthorizeNetSuccessSession = (token) => {
        try{
            const AuthorizeNetAddCardRequestURL =  (props.AffID && ASCSSettingData[props.AffID] ? 
                (JSON.parse(ASCSSettingData[props.AffID]).find((item)=>item.SubTitle === "CCOnProfileAuthorizeNetAddCardReuestURL").value) : 
                (JSON.parse(ASCSSettingData["-1"]).find((item)=>item.SubTitle === "CCOnProfileAuthorizeNetAddCardReuestURL").value)
            );
            setAuthorizeNetSessionURL(AuthorizeNetAddCardRequestURL);
            setAuthorizeNetToken(token);
            // console.log(AuthorizeNetAddCardRequestURL);
        }
        catch(err){console.log(err); setAddCardDisable(false); setShowPageLoader(false);}
    };
    //#endregion

    //#region SlimCD APIs & functions
    const handleSessionSuccessResponse = async (response, inloadURL) => {
        try{
            let myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let updateKey = (props.clientInfoData.Id ? props.clientInfoData.Id : -1);
            let checkSessionData = {"userid": updateKey, "sessionid": response.Sessionid, "waittime": 0, "iAffiliateID" : parseInt(props.AffID)};
            let checkSessionAPIURL = inloadURL + "/Payment" + "/CommonAPICall?MethodName=" + "CheckSession";
            let CheckSessionResponse = await APICom.fetchData("full", checkSessionAPIURL, "post", headersObj, checkSessionData);

            if(CheckSessionResponse && CheckSessionResponse.error.length === 0)
            {
                if(CheckSessionResponse.data && CheckSessionResponse.data.Sessionstatus)
                {
                    if(CheckSessionResponse.data.Sessionstatus === "success")
                    {
                        //Finished successfully
                        setAddCardDisable(false);
                        setSlimCDSessionURL("");
                        slimCDCCInfo.current = {UniqueID: CheckSessionResponse.data.UniqueID, Last4Digits: CheckSessionResponse.data.Last4Digits, 
                            ExpiryDate: CheckSessionResponse.data.ExpiryDate, CardType: CheckSessionResponse.data.CardType
                        };
                        
                        setCCInfoGridOptions(prevState=>({...prevState, height: 320}));
                        await initializeCCTable();
                    }
                    else if(CheckSessionResponse.data.Sessionstatus === "error")
                    {
                        setAddCardDisable(false);
                        setSlimCDSessionURL("");
                        setModalHeaderText("Creating Card Profile Error");
                        setModalBodyHTML(CheckSessionResponse.data.responseMessage);
                        setModalFooterHTML(
                            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                                OK
                            </Button>
                        );
                        setShowDynamicModal(true);
                        setCCInfoGridOptions(prevState=>({...prevState, height: 320}));
                    }
                    else
                    {
                        //Pending user response...
                        checkSessionCounter.current += 1;
                        setTimeout(async () => {
                            await handleSessionSuccessResponse(response, inloadURL)
                        }, 15000);
                    }
                }
            }
            else
            {
                //CheckSessionFailHandler (an unexpected error occured)
                setAddCardDisable(false);
                setSlimCDSessionURL("");
                setModalHeaderText("Creating Card Profile Error");
                setModalBodyHTML(CheckSessionResponse.error);
                setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                        OK
                    </Button>
                );
                setShowDynamicModal(true);
                setCCInfoGridOptions(prevState=>({...prevState, height: 320}));
            }
        }
        catch(err){
            console.log(err); //CheckSessionFailHandler
            setAddCardDisable(false);
            setSlimCDSessionURL("");
            setCCInfoGridOptions(prevState=>({...prevState, height: 320}));
        }
    };

    const handleAddCCSlimCD = async (inLoadAPIURL) =>{
        try{
            let myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let startSessionData = {"iAffiliateID": parseInt(props.AffID)};
            let createSessionAPIURL = inLoadAPIURL + "/Payment" + "/CommonAPICall?MethodName=" + "CreateSession";
            let CreateSessionResponse = await APICom.fetchData("full", createSessionAPIURL, "post", headersObj, startSessionData);

            if(CreateSessionResponse && CreateSessionResponse.error.length === 0)
            {
                if(CreateSessionResponse.data && CreateSessionResponse.data.responseMessage && CreateSessionResponse.data.responseMessage.toLowerCase().includes("success"))
                {
                    setSlimCDSessionURL(CreateSessionResponse.data.SessionUrl);
                    slimCDSessionID.current = CreateSessionResponse.data.Sessionid;
                    setTimeout(async () => {
                        await handleSessionSuccessResponse(CreateSessionResponse.data, inLoadAPIURL);  
                    }, 15000);
                }
            }
            else
            {
                setAddCardDisable(false);
                setModalHeaderText("Initializing Session Error");
                setModalBodyHTML(CreateSessionResponse.error);
                setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                        OK
                    </Button>
                );
                setShowDynamicModal(true);
            }
        }
        catch(err){console.log(err); setAddCardDisable(false);}
    };
    //#endregion

    //#region Common Functions
    const initializeCCTable = async (e) =>{ //API function to get the saved credit cards from DB when component loads
        try{
            setShowLoader(true);
            if(parseInt(bankChoiceFromSettings.current) === 1 || parseInt(bankChoiceFromSettings.current) === 0)
            {
                await handleGetActiveCCInfo();
            }
            else
            {
                setShowLoader(false);
                setWarningMessage("No existing cards found. Please first add a card to client profile.");
            }
        }
        catch(err){console.log(err); setShowLoader(false);}
    };

    const handleDeleteCustomerPaymentProfile = async (uniqueID) => {
        try{
            let myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let data = {
                forFS: false,
                affiliateID: parseInt(props.AffID),
                id: parseInt(uniqueID)
            };
            let DeleteCustomerProfileResponse = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/RemoveCC", "post", headersObj, data);
            // console.log(DeleteCustomerProfileResponse);
            setShowLoader(false);
            if(DeleteCustomerProfileResponse && DeleteCustomerProfileResponse.error === "" && DeleteCustomerProfileResponse.data !== "")
            {
                if(DeleteCustomerProfileResponse.data.Status.toUpperCase() !== "OK")
                {
                    setWarningMessage(DeleteCustomerProfileResponse.data.Error);
                    removeCCFlagRef.current = true;
                }
                else
                {
                    setWarningMessage("");
                    removeCCFlagRef.current = false;
                }
            }
            else
            {
                setWarningMessage("An error occurred while removing the card, please try again later.");
                removeCCFlagRef.current = true;
            }
        }
        catch(err){console.log(err); setShowLoader(false);}
    };

    const CheckCCAmount = async (data) => {
        try{
            let params = JSON.parse(data);
            params.cc_unique_id = cardInfo.uniqueID;
            let inloadURL = (GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL") ? GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL").value : "");
            if(inloadURL !== "")
            {
                let myHeaders = new Headers();
                myHeaders.append('Content-Type', 'application/json');
                let headersObj = headersToObject(myHeaders);
                let url = inloadURL + "/Payment" + "/CommonAPICall?MethodName=" + "CheckCCForPayment";
                if(props.pageLoader && typeof props.pageLoader === "function")
                    props.pageLoader(true);
                let response = await APICom.fetchData("full", url, "post", headersObj, params);

                if(props.pageLoader && typeof props.pageLoader === "function")
                    props.pageLoader(false);
                props.setCardDetails({...cardInfo, response: JSON.stringify(response)});
            }
        }
        catch(err){console.log(err); if(props.pageLoader && typeof props.pageLoader === "function"){props.pageLoader(false);}}
    };

    const handleCloseCCProfile = () => {
        try{
            setShowCCInfoDialog(false);
            props.setCCInfoDialog(false);
        }
        catch(err){console.log(err);}
    };

    const handleSelectCard = () => { //In Progress: initial function to close credit card dialog when a card is selected
        try{
            props.setCardDetails(cardInfo);
            handleCloseCCProfile();
        }
        catch(err){console.log(err);}
    };

    const handleRemoveCard = async (uniqueID) => { //In Progress: API function to remove card from saved cards of client reservation
        try{
            setShowLoader(true);
            let rowIndex = parseInt(uniqueID.split("_")[0]);
            const rowObj = CCInfoTableObjRef.current.getRow(rowIndex);
            if(rowObj)
            {

                if(parseInt(bankChoiceFromSettings.current) === 1 || parseInt(bankChoiceFromSettings.current) === 0) //Auth.net/SlimCD use same API for deletion of card
                {
                    await handleDeleteCustomerPaymentProfile(rowIndex);
                }

                if(!removeCCFlagRef.current)
                {
                    rowObj.delete();
                    // Get all remaining rows immediately after removal
                    const remainingRows = CCInfoTableObjRef.current.getRows();
                    if(remainingRows.length > 0)
                    {
                        let firstRowData = remainingRows[0].getData();
                        CCInfoTableObjRef.current.selectRow(firstRowData.UniqueID);
                        setCCInfoGridData((prevData) => 
                            prevData.filter((item) => parseInt(item.UniqueID) !== parseInt(rowIndex))
                        );
                    }
                    else
                    {
                        setCardInfo(prevState=>({...prevState, selectedCard: "", selectedExpiry: "", 
                            selectedCardType: "", response: ""
                        })); 
                        cardInfoRef.current.selectedCard = "";
                        setCCInfoGridData([{UniqueID:-1, CardType: "", Last4Digits: "", ExpiryDate: ""}]);
                        setWarningMessage("No existing cards found. Please first add a card to client profile.");
                    }
                }
            
            }
            else{ console.log("Row not found!"); }
        }
        catch(err){console.log(err); setShowLoader(false);}
    };

    const handleAddCCWithChoice = () => {
        try{
            setWarningMessage("");
            setAddCardDisable(true);
            if(parseInt(bankChoiceFromSettings.current) === 1)
            {
                //Get token for adding card to authorize.net
                handleAddCCAuthorizeNet(globalInLoadAPIURL.current);
            }
            else if(parseInt(bankChoiceFromSettings.current) === 0)
            {
                setCCInfoGridOptions(prevState=>({...prevState, height: 200}));
                //CreateSession API postData
                handleAddCCSlimCD(globalInLoadAPIURL.current);
            }
            else
            {
                setWarningMessage("No bank was appointed to this affiliate, please contact the administrator for details.")
            }
        }
        catch(err){console.log(err); setAddCardDisable(false); setWarningMessage("An error occured when adding the card, please try again later.");}
    };

    function headersToObject(headers) {
        try{
            let result = {};
            for (let [key, value] of headers.entries()) {
            result[key] = value;
            }
            return result;
        }
        catch(err){console.log(err); return headers;}
    };
    //#endregion

    return (
        <>
            <Modal centered className="" backdrop="static" keyboard={true}
                onHide={handleCloseCCProfile} show={showCCInfoDialog} animation={true}
            >
                <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                    <Modal.Title style={{fontSize:"20px"}}>{"Card Information"}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='fw-normal user-select-none'>

                    {warningMessage !== ""? 
                        <Row className="m-0 my-auto">
                            <Col className="p-0">
                                <p className="text-danger fw-bold small m-0 overflow-hidden user-select-none text-nowrap my-auto" 
                                    title={warningMessage} style={{textOverflow:"ellipsis", paddingLeft:"5px"}}
                                >
                                    {warningMessage}
                                </p>
                            </Col>
                        </Row> 
                    : ""}
                    {showPageLoader ? <div className="loader"></div> : ""}

                    {slimCDSessionURL !== "" ?
                        <Row className="m-0 my-auto">
                            <Col className="p-0">
                                <iframe
                                    title="SlimCD"
                                    src={slimCDSessionURL}
                                    className="text-center justify-content-center w-100 bg-transparent overflow-auto border-0"
                                    style={{
                                        height: '440px',
                                    }}
                                />
                            </Col>
                        </Row>
                    :""}
                    
                    {AuthorizeNetSessionURL !== "" && AuthorizeNetToken !== ""?                        
                        <Row className="m-0 my-auto">
                            <Col className="p-0">
                                {!formSubmitted ? 
                                    <Form
                                        title="Authorize.net"
                                        method="post"
                                        action={AuthorizeNetSessionURL}
                                        target="AddCardAuthNetFrame"
                                        className="text-center justify-content-center w-100 overflow-auto"
                                        ref={authorizeNetFormRef}
                                        style={{
                                            height: '240px',
                                        }}
                                    >
                                        <input type="hidden" id="token" name="token" value={AuthorizeNetToken} />
                                    </Form> 
                                : ""}
                                <iframe
                                    title="Authorize.net"
                                    name="AddCardAuthNetFrame"
                                    id="authorizeIframe"
                                    className="text-center justify-content-center w-100 bg-transparent overflow-auto border-0"
                                    style={{
                                        height: "240px",
                                        zoom: "0.8"
                                    }}
                                />
                            </Col>
                        </Row>
                    : ""}

                    <Row className="m-0 mt-3">
                        <GridControl ShowLoader={showLoader} ReloadDataFunction={(e)=>{}} 
                            setCardToRemove={setCardToRemove} Data={CCInfoGridData} options={CCInfoGridOptions}
                        />
                    </Row> 
                    <Row className="m-0 mt-1">
                        <Col className="p-0 rounded border border-dark overflow-auto callAgentSummaryScroller">
                            <span className="d-block small fw-bold mt-1 text-nowrap overflow-hidden">
                                <Icon icon="mdi:credit-card-check-outline" className="mb-1 mx-1 text-success" style={{width:"15px", height:"15px"}}/>
                                <label className='m-0 user-select-none'>Card Selected</label>
                            </span>
                            <Row className="m-0">
                                <Col className="my-1" xs={6}>
                                    <span className="d-flex small my-auto text-nowrap" title={"Card Type"}>
                                        <label className='m-0 user-select-none'>Card Type:</label>
                                        <input type="text" value={(String(cardInfo.selectedCardType).trim())}
                                            onChange={(e)=>{}}
                                            className="m-0 ms-2 px-1 text-center overflow-hidden callAgentInputStyle" style={{minWidth:"60px", maxWidth:"135px", boxSizing:"border-box"}} 
                                            autoComplete="new_pass" readOnly
                                            title={(String(cardInfo.selectedCardType).trim())}
                                        />  
                                    </span>
                                    <span className="d-flex small my-auto mt-1 text-center justify-content-end text-nowrap" title={"Card Expiration Date"}>
                                        <label className='m-0 user-select-none'>Expiry:</label>
                                        <input type="text" value={cardInfo.selectedExpiry}
                                            onChange={(e)=>{}}
                                            className="m-0 ms-2 px-1 text-center overflow-hidden callAgentInputStyle" 
                                            style={{minWidth:"60px", maxWidth:"135px", boxSizing:"border-box"}} 
                                            autoComplete="new_pass" readOnly
                                            title={cardInfo.selectedExpiry}
                                        />  
                                    </span>
                                </Col>
                                <Col className="my-1" xs={6}>
                                    <span className="d-flex small my-auto text-nowrap" title={"Last 4 digits of card"}>
                                        <label className='m-0 user-select-none'>Last4Digits:</label>
                                        <input type="text" value={(cardInfo.selectedCard !== "" ? cardInfo.selectedCard : "")} maxLength={4}
                                            onChange={(e)=>{}}
                                            className="m-0 ms-2 px-1 text-center overflow-hidden callAgentInputStyle" style={{minWidth:"60px", maxWidth:"135px", 
                                                boxSizing:"border-box"
                                            }} autoComplete="new_pass" readOnly
                                            title={(cardInfo.selectedCard !== "" ? cardInfo.selectedCard : "")}
                                        />  
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                
                </Modal.Body>
                <Modal.Footer className='p-0 px-2 py-1'>
                    <Button variant="dark" className="mx-1" onClick={handleAddCCWithChoice} disabled={AddCardDisable}>Add Card</Button>
                    <Button variant="dark" className="mx-1" onClick={handleSelectCard} disabled={(!CCInfoGridData || CCInfoGridData.length === 0 || warningMessage !== "")}>Select Card</Button>
                </Modal.Footer>
            </Modal>

            {showDynamicModal ? 
                <Modal centered backdrop="static" keyboard={true} size={"md"}
                    onKeyDown={(e)=>
                    {
                        if(e.key === "Enter")
                        {
                            e.preventDefault();
                            setShowDynamicModal(false);
                        }
                    }} 
                    onHide={()=>{setShowDynamicModal(false);}} show={showDynamicModal} animation={true}
                >
                    <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                        <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
                    {modalFooterHTML === ""? "":
                    <Modal.Footer className='p-0 px-2 py-1'>
                        {modalFooterHTML}
                    </Modal.Footer>
                    }
                </Modal>
            : ""}

        </>
    );
};

export default CCProfile;